import Swal from 'sweetalert2';

export async function promptCertificateLayout(): Promise<boolean | undefined> {
  const result = await Swal.fire({
    title: 'Certificate Layout',
    input: 'radio',
    inputOptions: {
      compact: 'Compact',
      expanded: 'Expanded',
    },

    inputValue: 'compact',
    showCancelButton: true,
    confirmButtonText: 'Continue',
  });

  if(!result.isConfirmed) {
    return undefined;
  }

  return result.value === 'compact';
}
